@if (this.hidePopup == false;) {
<div class="modal fade show" [ngClass]="{'expanded':isExpanded}" tabindex="-1"
  aria-labelledby="service-order-modalLabel" aria-hidden="true" [ngStyle]="{'display': 'block'}"
 >
  <div class="modal-dialog modal-xl">
    @if (showLoader) {
<app-loader></app-loader>
}
    <div class="modal-content">
      <div class="modal-header" (onExpandCollapse)="isExpanded = $event">
        <div class="d-flex w-100">
          <div class="me-2 id flex-fill">
            <span class="custom-icon">
              <i id="header-cart" class="fa fa-shopping-cart rotation" aria-hidden="true"></i>
            </span>
            <span class="modal-title mt-2 item-id">MY CART</span>
          </div>
          <div class="btns-header">
            <button class="header-icon close p-0 m-0" (click)="onCloseCart()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <button class="close header-icon expand-modal p-0 m-0" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col mt-4">
            @if (gridConfig) {
            <div [style.height.px]="gridHeight">
              <inavista-grid #cartGrid class="so-popup-grid"
                [config]="gridConfig"
                [actionIcons]="actionIcons"
                (rowsSelected)="onRowsSelected($event)"
                (actionComplete)="onActionComplete()"
                (hyperlinkClick)="onHyperlinkClick($event)"
                (actionIconClick)="onActionIconClick($event)" />
            </div>
            }
            <div class="row container fluid mt-2">
              <div class="col-3"></div>
              <div class="col-2 item-id">Total quantity: {{totalQuantity}}</div>
              <div class="col-3 item-id">Total amount: {{totalPrice?.toFixed(2)}}</div>
              <div class="col-2" style="color:green"><b class="item-id">Savings: {{totalSavings?.toFixed(2)}}</b>
              </div>
              <div class="col-2"><b class="item-id">Currency: {{currency}}</b></div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger close-modal" (click)="onCloseCart()">Close</button>
        <button type="button" class="btn btn-sm btn-primary close-modal" (click)="clearCart()"><i
            class="fas fa-trash me-2"></i>Clear Cart</button>
        <button type="button" class="btn btn-sm btn-warning close-modal" style="color: white;" [disabled]="!data?.length" (click)="checkAvailability()">Check Availability</button>
        <button type="button" class="btn btn-sm btn-success close-modal" (click)="openCheckout()"
          [disabled]="isCheckoutButtonDisabled"><i class="fas fa-share-square mx-1"></i>Checkout</button>
      </div>
    </div>
  </div>
</div>
}

@if (showCartCheckoutPopup) {
<app-cart-checkout-popup
 
  [serviceOrderId]="serviceOrderId"
  [onsiteAddress]="onsiteAddress"
  [recievedItems]="selectedItemsToCheckout"
  (onClose)="onCloseFromCheckout()">
</app-cart-checkout-popup>
}

<!-- Order Qty, as the old column template: − / whole number (at least 1) / +. -->
<ng-template #quantityCell let-row>
  <div class="qty" (click)="$event.stopPropagation()">
    <button type="button" class="qty-gen" title="Decrease quantity" (click)="sub(row)">-</button>
    <input type="number" class="qty-input" min="1" step="1" required
      [value]="row?.quantity"
      (change)="onQuantityInput($event, row)"
      (keydown)="$event.stopPropagation()" />
    <button type="button" class="qty-gen" title="Increase quantity" (click)="add(row)">+</button>
  </div>
</ng-template>
